import { TranslationObject } from '@ngx-translate/core';

export function parseProperties(text: string): TranslationObject {
  const result: TranslationObject = {};
  for (const line of text.split('\n')) {
    const trimmed = line.trim();
    if (!trimmed || trimmed.startsWith('#')) continue;
    const eqIndex = trimmed.indexOf('=');
    if (eqIndex === -1) continue;
    const key = trimmed.slice(0, eqIndex).trim();
    result[key] = trimmed.slice(eqIndex + 1).replace(/\\n/g, '\n');
  }
  return result;
}
